/**
 * Sentry for the frontend. No-op unless VITE_SENTRY_DSN is set at build time.
 * Sends uncaught errors and failed React renders only — no session replay,
 * no performance traces, no PII (the user id is attached, never the email).
 */
import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN;

export function initErrorMonitoring() {
  if (!DSN) return false;
  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    sendDefaultPii: false,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event) {
      // Network blips on set are expected, not bugs.
      const msg = event?.exception?.values?.[0]?.value || '';
      if (/Network Error|Failed to fetch|Load failed|timeout of \d+ms exceeded/i.test(msg)) return null;
      return event;
    },
  });
  return true;
}

export function setMonitoredUser(user) {
  if (!DSN) return;
  Sentry.setUser(user?.id ? { id: user.id } : null);
}

export const ErrorBoundary = Sentry.ErrorBoundary;
